import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { MainPageWithButtons, TextInputComponent, CapsuleButton } from "../_components";
import { LicensesActions } from "../_actions/LicensesActions";
import { BudgetsUiAlertsActions } from "../_actions/BudgetsUiAlertsActions";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Icons } from "../../Common/_assets/icons/Icons";
import { genericActions } from "../_helpers/ActionErrorWrapper"
import { getSellableLicenseTypes } from "./getSellableLicenseTypes";
import { LicenseTypeSelector } from "./LicenseTypeSelector";
import { isClockinsLicenseType, VirtualClockinCheckbox } from "./VirtualClockinCheckbox";


export function AssignLicenseView({licenseTypes, onAssignSuccess, initialLocationId = "", initialEmail = ""}) {

    //LIBRARIES
    const dispatch = useDispatch();
    const { t } = useTranslation();

    //LOCAL STATE
    const [locationID, setLocationID] = useState(initialLocationId);
    const [email, setEmail] = useState(initialEmail);
    const [quantity, setQuantity] = useState(0);
    const [licenseTypeUID, setLicenseTypeUID] = useState("");
    const [createVirtualClockin, setCreateVirtualClockin] = useState(false);

    //VIEW

    const filteredLicenseTypes = getSellableLicenseTypes(licenseTypes);

    return (
        <MainPageWithButtons
            pageTitle={t("mod_budgets_assign_license")}
            content={content()}
        />
    );

    function areAllFieldsValid() {
        return locationID && licenseTypeUID && quantity && email
    }

    function LocationIDInfoTooltip() {
    return (
        <div>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-id-loc">
                        {t("mod_budgets_location_id_info_tooltip")}
                    </Tooltip>
                }
            >
            <img 
                src={Icons.info} 
                alt="info" 
                className="mx-2 mb-1" 
                style={{ width: '16px', height: '16px', cursor: 'help' }} 
            />
            </OverlayTrigger>
        </div>
    );
    }

    function content() {
        return (
            <div>
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("mod_budgets_license_type")}
                </div>
                {licenseTypeFn()}
                {isClockinsLicenseType(filteredLicenseTypes, licenseTypeUID) &&
                    <VirtualClockinCheckbox
                        checked={createVirtualClockin}
                        onChange={setCreateVirtualClockin}
                    />
                }
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase d-flex align-items-center">
                    <div>{t("mod_budgets_location_id")}</div>
                    <LocationIDInfoTooltip />
                </div>
                <TextInputComponent
                    title={t("mod_budgets_location_id")}
                    value={locationID}
                    onChange={setLocationID}
                />
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("mod_budgets_owner_email")}
                </div>
                <TextInputComponent
                    title={t("global_email")}
                    value={email}
                    onChange={setEmail}
                />
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("mod_budgets_quantity")}
                </div>
                <TextInputComponent
                    title={t("mod_budgets_quantity")}
                    value={quantity}
                    onChange={setQuantity}
                />
                <div className="mt-4"/>
                <CapsuleButton
                    isEnabled={areAllFieldsValid()}
                    onClick={handleAssignLicense}
                    text={t("mod_budgets_assign")}
                />
            </div>
        );
    }

    function licenseTypeFn() {
        return (
            <LicenseTypeSelector
                licenseTypes={filteredLicenseTypes}
                value={licenseTypeUID}
                onChange={handleLicenseTypeChange}
            />
        );
    }

    function handleLicenseTypeChange(uid) {
        setLicenseTypeUID(uid);
        setCreateVirtualClockin(isClockinsLicenseType(filteredLicenseTypes, uid));
    }

    async function handleAssignLicense() {
        dispatch(LicensesActions.assignLicense({locationID, email, licenseTypeUID, quantity, createVirtualClockin})).then((result) => {
            // Solo se ejecuta si la promesa se resuelve (Success)
            dispatch(LicensesActions.changeSecondaryView(null));
            dispatch(BudgetsUiAlertsActions.showSuccessAlert(t("mod_budgets_assign_successful") + " ID: " + result.id))
            onAssignSuccess(result);
        }).catch((error) => {
            dispatch(genericActions.errorCatch(error));
        });
    }
}
